import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Template from 'views/partner/templates/pdf/template'; // Importing a template for PDF
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * TemplateView class extends JetView to create a specific view for templates.
 */
export default class TemplateView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying theme to the toolbar
                    elements: [
                        {
                            css: 'user-selected', // CSS class for styling
                            view: 'label', // Label component
                            id: 'lblTittle', // Unique identifier for the label
                            align: 'center', // Center alignment for the label
                        },
                    ],
                },
                Template, // Including the imported template
            ],
        };
        webix.ui.fullScreen(); // Setting the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Vertical scrolling enabled
            rows: [
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Wide type for layout
                    cols: [left], // Columns layout including the left section
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up necessary parameters.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Retrieving partner ID from parameters
        const id = this.getParam('id', true); // Retrieving template ID from parameters
        $$('lblTittle').setValue(
            // Setting the value of the label
            "<div class='username-active'><div style='font-weight: normal'>" +
                _('Id Plantilla') + // Localized label for 'Template ID'
                ': &nbsp;</div><div>' +
                id + // Displaying the template ID
                '</div></div>',
        );
    }
}

// FILE DOCUMENTED
